import {handleActions} from 'redux-actions';
import * as actions from './actions';
import {IFetchState} from "../stickers/reducer";

export interface IStickerItem {
    id: string;
    sticker_id: string
    type: string;
    title?: string;
    format: string;

    from?: any;
    created_date: Date;
    sent_date: Date;
    configured_date: Date;

    greeting_text: string;
    thanks_text: string;

    template: string;
    photo?: any;
    audio?: any;
    video?: any;

    views_count?: number;

    is_need_convert_video?: boolean;
    new_comments_count?: number;
    new_views_count?: number;
}

export interface IStickerItemsState {
    byId: { [key: string]: IStickerItem }
    ids: string[],
    fetchState: { [key: string]: IFetchState },
    deleteState: { [key: string]: IFetchState },
}


const defaultState: IStickerItemsState = {
    byId: {},
    ids: [],
    fetchState: {},
    deleteState: {},
};

const reducer = handleActions(
    // @ts-ignore
    new Map([
        [actions.stickerItemsLoadRequest,
            (state: IStickerItemsState, action: { payload: { stickerId: string } }) => {
                const {stickerId} = action.payload;
                return {
                    ...state,
                    fetchState: {
                        ...state.fetchState,
                        [stickerId]: {
                            status: 'loading',
                            error: null
                        }
                    }
                }
            }],
        [actions.stickerItemsLoadSuccess,
            (state: IStickerItemsState, action: { payload: { stickerId: string, stickerItems: IStickerItem[] } }) => {
                const {stickerId, stickerItems} = action.payload;
                return {
                    ...state,
                    isLoading: false,
                    isLoadingError: false,
                    byId: stickerItems.reduce((obj, item) => ({...obj, [item.id]: item}), {...state.byId}),
                    ids: [...new Set([...state.ids, ...stickerItems.map(item => item.id)])],
                    fetchState: {
                        ...state.fetchState,
                        [stickerId]: {
                            status: 'succeeded',
                            error: null
                        }
                    }
                }
            }],
        [actions.stickerItemsLoadFailed,
            (state: IStickerItemsState, action: { payload: { stickerId: string, error: Error } }) => {
                const {stickerId, error} = action.payload;
                return {
                    ...state,
                    fetchState: {
                        ...state.fetchState,
                        [stickerId]: {
                            status: 'failed',
                            error: error
                        }
                    }
                }
            }],
        [actions.stickerItemDeleteRequest,
            (state: IStickerItemsState, action: { payload: { stickerId: string, stickerItemId: string } }) => {
                const {stickerId, stickerItemId} = action.payload;
                return {
                    ...state,
                    deleteState: {
                        ...state.deleteState,
                        [`${stickerId}-${stickerItemId}`]: {
                            status: 'loading',
                            error: null
                        }
                    }
                }
            }],
        [actions.stickerItemDeleteSuccess,
            (state: IStickerItemsState, action: { payload: { stickerId: string, stickerItemId: string } }) => {
                const {stickerId, stickerItemId} = action.payload;
                const byId = {...state.byId}
                delete byId[stickerItemId];
                const ids = [...state.ids].filter(id => id !== stickerItemId)
                return {
                    ...state,
                    byId,
                    ids,
                    deleteState: {
                        ...state.deleteState,
                        [`${stickerId}-${stickerItemId}`]: {
                            status: 'succeeded',
                            error: null
                        }
                    }
                }
            }],
        [actions.stickerItemDeleteFailed,
            (state: IStickerItemsState, action: { payload: { stickerId: string, stickerItemId: string, error: Error } }) => {
                const {stickerId, stickerItemId, error} = action.payload;
                return {
                    ...state,
                    deleteState: {
                        ...state.deleteState,
                        [`${stickerId}-${stickerItemId}`]: {
                            status: 'failed',
                            error: error
                        }
                    }
                }
            }],
    ]),
    defaultState
);

export default reducer;
